import { useEffect, useRef } from "react";
import { Bold, Italic, Highlighter, List, Eraser } from "lucide-react";

export function RichTextEditor({ value, onChange, testid = "rich-editor" }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) ref.current.innerHTML = value || "";
  }, [value]);
  const emit = () => onChange(ref.current.innerHTML);
  const cmd = (c) => { ref.current.focus(); document.execCommand(c, false, null); emit(); };
  const mark = () => {
    const sel = window.getSelection();
    if (!sel.rangeCount || sel.isCollapsed || !ref.current.contains(sel.anchorNode)) return;
    const range = sel.getRangeAt(0);
    const m = document.createElement("mark");
    m.appendChild(range.extractContents());
    range.insertNode(m);
    sel.removeAllRanges();
    emit();
  };
  const unmark = () => {
    ref.current.querySelectorAll("mark").forEach((m) => {
      const sel = window.getSelection();
      if (sel.rangeCount && sel.getRangeAt(0).intersectsNode(m)) m.replaceWith(...m.childNodes);
    });
    cmd("removeFormat");
  };
  const btn = (id, Icon, label, fn) => (
    <button type="button" data-testid={`${testid}-${id}`} title={label} onMouseDown={(e) => { e.preventDefault(); fn(); }}
      className="press h-8 px-2 rounded flex items-center gap-1 text-xs hover:bg-slate-200"><Icon className="w-3.5 h-3.5" /> <span className="hidden sm:inline">{label}</span></button>
  );
  return (
    <div className="rounded-md border border-slate-200 bg-white focus-within:ring-2 focus-within:ring-brand-yellow/60">
      <div className="flex flex-wrap gap-0.5 border-b bg-slate-50 p-1">
        {btn("bold", Bold, "Grassetto", () => cmd("bold"))}
        {btn("italic", Italic, "Corsivo", () => cmd("italic"))}
        {btn("mark", Highlighter, "Evidenzia", mark)}
        {btn("list", List, "Elenco", () => cmd("insertUnorderedList"))}
        {btn("clear", Eraser, "Togli formato", unmark)}
      </div>
      <div ref={ref} data-testid={testid} contentEditable suppressContentEditableWarning onInput={emit} onBlur={emit}
        className="rich-text min-h-[90px] p-3 text-sm focus:outline-none" />
      <p className="px-3 pb-2 text-[11px] text-slate-500">Seleziona il testo e premi "Evidenzia" per farlo risaltare. Le misure (es. 14x38 mm) vengono evidenziate in automatico.</p>
    </div>
  );
}
